export const hideLoader = () => {
  const root = document.getElementById("root");
  root.classList.remove("hidden");
  document.getElementById("preloader").outerHTML = "";
};
